import { h, Fragment } from "preact";

import CardTemplate from "../Common/CardTemplate";
import BuyerCard from "../Common/BuyerCard";

export default function BuyersCard({ actualDeal, mode, btn }) {

    return (
        <CardTemplate
            title="Acquéreurs"
            buttons={btn}
            content={actualDeal.buyers && actualDeal.buyers.length > 0 ?
                actualDeal.buyers.map((row) => {
                    return <BuyerCard row={row} mode={mode} />;
                }) : <em>Pas d'acquéreur enregistré</em>
            }
        />)

}